import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class RoomAPI {

  static ModelNo = 54;

  static saveRoom = (room, success, failure, logout) => {
    fetch(Config.app.link + 'api/room/add-edit', new Header('POST', room))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static getRoom = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/room/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure, logout) => {
    const filter = [{field: "tower_id", type: "number", condition: "equals", 
      value: modelId}];
    const page = 1;
    const perPage = 10;
    fetch(Config.app.link + 'api/room/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/room/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static massDelete = (ids, success, failure, logout) => {
    fetch(Config.app.link + 'api/room/mass-delete', new Header('POST', ids))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static massUpdate = (body, success, failure, logout) => {
    fetch(Config.app.link + 'api/room/mass-update', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static options = (success, failure, logout) => {
    fetch(Config.app.link + 'api/room/options', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }
}

export default RoomAPI;